/* unplugin-vue-components disabled */import { render } from "./GeneralMessageModal.vue?vue&type=template&id=55c49c96&ts=true"
import script from "./GeneralMessageModal.vue?vue&type=script&lang=ts"
export * from "./GeneralMessageModal.vue?vue&type=script&lang=ts"

import "./GeneralMessageModal.vue?vue&type=style&index=0&id=55c49c96&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_9SbA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__